import { forwardRef, useCallback } from 'react'

import StreamableVideo, { StreamableVideoHandle } from '../StreamableVideo'

export type MuxPlayerHandle = StreamableVideoHandle

type MuxPlayerProps = {
  playbackId: string
  onPlay?: (playbackId: string) => void
  fullscreenOnPlay?: boolean
}

const streamUrl = (playbackId: string) =>
  `https://stream.mux.com/${playbackId}.m3u8`

const posterUrl = (playbackId: string) =>
  `https://image.mux.com/${playbackId}/thumbnail.jpg?width=1920&height=1080&fit_mode=preserve`

const MuxPlayer = forwardRef<MuxPlayerHandle, MuxPlayerProps>(
  ({ playbackId, onPlay, fullscreenOnPlay }, ref) => {
    const handlePlay = useCallback(
      () => onPlay?.(playbackId),
      [onPlay, playbackId],
    )

    return (
      <StreamableVideo
        ref={ref}
        src={streamUrl(playbackId)}
        poster={posterUrl(playbackId)}
        onPlay={handlePlay}
        fullscreenOnPlay={fullscreenOnPlay}
        objectFit="contain"
        browserControls
      />
    )
  },
)

export default MuxPlayer
